export default __webpack_public_path__ + "mapFront.min.css";